import React from 'react';
import LandingIndex from '../index';

export default function () {
  return <LandingIndex noFixedVideo noExitIntent noShareButtons variant="ad" />;
}
